/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CitaModelDto } from '../models/cita-model-dto';
import { citasControllerAnulacionDeCita } from '../fn/paciente-citas/citas-controller-anulacion-de-cita';
import { CitasControllerAnulacionDeCita$Params } from '../fn/paciente-citas/citas-controller-anulacion-de-cita';
import { citasControllerCrearCita } from '../fn/paciente-citas/citas-controller-crear-cita';
import { CitasControllerCrearCita$Params } from '../fn/paciente-citas/citas-controller-crear-cita';
import { citasControllerFechaMinMaxCrearCita } from '../fn/paciente-citas/citas-controller-fecha-min-max-crear-cita';
import { CitasControllerFechaMinMaxCrearCita$Params } from '../fn/paciente-citas/citas-controller-fecha-min-max-crear-cita';
import { citasControllerFechaMinMaxReprogramarCita } from '../fn/paciente-citas/citas-controller-fecha-min-max-reprogramar-cita';
import { CitasControllerFechaMinMaxReprogramarCita$Params } from '../fn/paciente-citas/citas-controller-fecha-min-max-reprogramar-cita';
import { citasControllerMarcarCitaReprogramadaLeida } from '../fn/paciente-citas/citas-controller-marcar-cita-reprogramada-leida';
import { CitasControllerMarcarCitaReprogramadaLeida$Params } from '../fn/paciente-citas/citas-controller-marcar-cita-reprogramada-leida';
import { citasControllerObtencionCita } from '../fn/paciente-citas/citas-controller-obtencion-cita';
import { CitasControllerObtencionCita$Params } from '../fn/paciente-citas/citas-controller-obtencion-cita';
import { citasControllerObtencionCitas } from '../fn/paciente-citas/citas-controller-obtencion-citas';
import { CitasControllerObtencionCitas$Params } from '../fn/paciente-citas/citas-controller-obtencion-citas';
import { citasControllerReprogramarCita } from '../fn/paciente-citas/citas-controller-reprogramar-cita';
import { CitasControllerReprogramarCita$Params } from '../fn/paciente-citas/citas-controller-reprogramar-cita';
import { FechaMinMaxReproModelDto } from '../models/fecha-min-max-repro-model-dto';
import { ReprogramarFechaModelDto } from '../models/reprogramar-fecha-model-dto';

@Injectable({ providedIn: 'root' })
export class PacienteCitasService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `citasControllerCrearCita()` */
  static readonly CitasControllerCrearCitaPath = '/api/citas/crear-cita';

  /**
   * Crear una nueva cita.
   *
   * Permite crear una nueva cita para el paciente autenticado.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `citasControllerCrearCita()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  citasControllerCrearCita$Response(params: CitasControllerCrearCita$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return citasControllerCrearCita(this.http, this.rootUrl, params, context);
  }

  /**
   * Crear una nueva cita.
   *
   * Permite crear una nueva cita para el paciente autenticado.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `citasControllerCrearCita$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  citasControllerCrearCita(params: CitasControllerCrearCita$Params, context?: HttpContext): Observable<void> {
    return this.citasControllerCrearCita$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `citasControllerObtencionCitas()` */
  static readonly CitasControllerObtencionCitasPath = '/api/citas/obtener-citas';

  /**
   * Obtener citas.
   *
   * Obtiene una lista de citas del paciente especificado
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `citasControllerObtencionCitas()` instead.
   *
   * This method doesn't expect any request body.
   */
  citasControllerObtencionCitas$Response(params?: CitasControllerObtencionCitas$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CitaModelDto>>> {
    return citasControllerObtencionCitas(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtener citas.
   *
   * Obtiene una lista de citas del paciente especificado
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `citasControllerObtencionCitas$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  citasControllerObtencionCitas(params?: CitasControllerObtencionCitas$Params, context?: HttpContext): Observable<Array<CitaModelDto>> {
    return this.citasControllerObtencionCitas$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CitaModelDto>>): Array<CitaModelDto> => r.body)
    );
  }

  /** Path part for operation `citasControllerMarcarCitaReprogramadaLeida()` */
  static readonly CitasControllerMarcarCitaReprogramadaLeidaPath = '/api/citas/marcar-cita-reprogramada-leida/{uuidCita}';

  /**
   * Marcará una cita como léida.
   *
   * Marca una cita como leída para el paciente autenticado.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `citasControllerMarcarCitaReprogramadaLeida()` instead.
   *
   * This method doesn't expect any request body.
   */
  citasControllerMarcarCitaReprogramadaLeida$Response(params: CitasControllerMarcarCitaReprogramadaLeida$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return citasControllerMarcarCitaReprogramadaLeida(this.http, this.rootUrl, params, context);
  }

  /**
   * Marcará una cita como léida.
   *
   * Marca una cita como leída para el paciente autenticado.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `citasControllerMarcarCitaReprogramadaLeida$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  citasControllerMarcarCitaReprogramadaLeida(params: CitasControllerMarcarCitaReprogramadaLeida$Params, context?: HttpContext): Observable<void> {
    return this.citasControllerMarcarCitaReprogramadaLeida$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `citasControllerObtencionCita()` */
  static readonly CitasControllerObtencionCitaPath = '/api/citas/obtener-cita/{uuidCita}';

  /**
   * Obtener cita.
   *
   * Obtiene información específica de una cita por su uuid
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `citasControllerObtencionCita()` instead.
   *
   * This method doesn't expect any request body.
   */
  citasControllerObtencionCita$Response(params: CitasControllerObtencionCita$Params, context?: HttpContext): Observable<StrictHttpResponse<CitaModelDto>> {
    return citasControllerObtencionCita(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtener cita.
   *
   * Obtiene información específica de una cita por su uuid
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `citasControllerObtencionCita$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  citasControllerObtencionCita(params: CitasControllerObtencionCita$Params, context?: HttpContext): Observable<CitaModelDto> {
    return this.citasControllerObtencionCita$Response(params, context).pipe(
      map((r: StrictHttpResponse<CitaModelDto>): CitaModelDto => r.body)
    );
  }

  /** Path part for operation `citasControllerReprogramarCita()` */
  static readonly CitasControllerReprogramarCitaPath = '/api/citas/reprogramar-cita/{uuidCita}';

  /**
   * Reprogramar una cita.
   *
   * Reprograma una cita para el paciente autenticado.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `citasControllerReprogramarCita()` instead.
   *
   * This method doesn't expect any request body.
   */
  citasControllerReprogramarCita$Response(params: CitasControllerReprogramarCita$Params, context?: HttpContext): Observable<StrictHttpResponse<ReprogramarFechaModelDto>> {
    return citasControllerReprogramarCita(this.http, this.rootUrl, params, context);
  }

  /**
   * Reprogramar una cita.
   *
   * Reprograma una cita para el paciente autenticado.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `citasControllerReprogramarCita$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  citasControllerReprogramarCita(params: CitasControllerReprogramarCita$Params, context?: HttpContext): Observable<ReprogramarFechaModelDto> {
    return this.citasControllerReprogramarCita$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReprogramarFechaModelDto>): ReprogramarFechaModelDto => r.body)
    );
  }

  /** Path part for operation `citasControllerFechaMinMaxReprogramarCita()` */
  static readonly CitasControllerFechaMinMaxReprogramarCitaPath = '/api/citas/fecha-min-max-reprogramar-cita';

  /**
   * Obtención de fecha Mínima/Máxima para reprogramación de citas.
   *
   * Obtiene la fecha mínima y máxima para la reprogramación de citas.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `citasControllerFechaMinMaxReprogramarCita()` instead.
   *
   * This method doesn't expect any request body.
   */
  citasControllerFechaMinMaxReprogramarCita$Response(params?: CitasControllerFechaMinMaxReprogramarCita$Params, context?: HttpContext): Observable<StrictHttpResponse<FechaMinMaxReproModelDto>> {
    return citasControllerFechaMinMaxReprogramarCita(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtención de fecha Mínima/Máxima para reprogramación de citas.
   *
   * Obtiene la fecha mínima y máxima para la reprogramación de citas.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `citasControllerFechaMinMaxReprogramarCita$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  citasControllerFechaMinMaxReprogramarCita(params?: CitasControllerFechaMinMaxReprogramarCita$Params, context?: HttpContext): Observable<FechaMinMaxReproModelDto> {
    return this.citasControllerFechaMinMaxReprogramarCita$Response(params, context).pipe(
      map((r: StrictHttpResponse<FechaMinMaxReproModelDto>): FechaMinMaxReproModelDto => r.body)
    );
  }

  /** Path part for operation `citasControllerFechaMinMaxCrearCita()` */
  static readonly CitasControllerFechaMinMaxCrearCitaPath = '/api/citas/fecha-min-max-crear-cita';

  /**
   * Obtención de fecha Mínima/Máxima para creación de citas.
   *
   * Obtiene la fecha mínima y máxima para la creación de citas.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `citasControllerFechaMinMaxCrearCita()` instead.
   *
   * This method doesn't expect any request body.
   */
  citasControllerFechaMinMaxCrearCita$Response(params?: CitasControllerFechaMinMaxCrearCita$Params, context?: HttpContext): Observable<StrictHttpResponse<FechaMinMaxReproModelDto>> {
    return citasControllerFechaMinMaxCrearCita(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtención de fecha Mínima/Máxima para creación de citas.
   *
   * Obtiene la fecha mínima y máxima para la creación de citas.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `citasControllerFechaMinMaxCrearCita$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  citasControllerFechaMinMaxCrearCita(params?: CitasControllerFechaMinMaxCrearCita$Params, context?: HttpContext): Observable<FechaMinMaxReproModelDto> {
    return this.citasControllerFechaMinMaxCrearCita$Response(params, context).pipe(
      map((r: StrictHttpResponse<FechaMinMaxReproModelDto>): FechaMinMaxReproModelDto => r.body)
    );
  }

  /** Path part for operation `citasControllerAnulacionDeCita()` */
  static readonly CitasControllerAnulacionDeCitaPath = '/api/citas/anular-cita';

  /**
   * Notificar cumplimentación de cuestionario de anulación.
   *
   * Notifica al médico para anular una cita de paciente tras haber tenido la analítica correcta
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `citasControllerAnulacionDeCita()` instead.
   *
   * This method doesn't expect any request body.
   */
  citasControllerAnulacionDeCita$Response(params?: CitasControllerAnulacionDeCita$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return citasControllerAnulacionDeCita(this.http, this.rootUrl, params, context);
  }

  /**
   * Notificar cumplimentación de cuestionario de anulación.
   *
   * Notifica al médico para anular una cita de paciente tras haber tenido la analítica correcta
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `citasControllerAnulacionDeCita$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  citasControllerAnulacionDeCita(params?: CitasControllerAnulacionDeCita$Params, context?: HttpContext): Observable<void> {
    return this.citasControllerAnulacionDeCita$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
